import { lazy, Suspense } from 'react';

const Admin = lazy(() => import('./admin/Admin'));
// Кабинет клиента — отдельный чанк со своим роутером и стилями: у админки и клиента общая
// сборка, но независимые миры (разделение по префиксу пути).
const Client = lazy(() => import('./client/Client'));

function App() {
    const isAdminArea = window.location.pathname.startsWith('/admin');
    return (
        <Suspense fallback={null}>
            {isAdminArea ? <Admin /> : <Client />}
        </Suspense>
    );
}

export default App;
